import {
    GET_BOOKING_SAGA,
    SEND_BOOKING_SAGA,
    REGISTRATION_SAGA,
    CHECK_EMAIL_CODE_SAGA,
    RECOVERY_PASSWORD_SAGA,
    GET_FILTERS_SAGA,
    SIGN_IN_SAGA,
    CHECK_HASH_SAGA,
    GET_SUBSCRIPTIONS_SAGA,
    BOOKING_ACTION_SAGA,
    GET_SERVICES_SAGA,
    GET_MASTERS_SAGA,
    GET_TIMETABLE_SAGA,
    ADD_SCHEDULE_RESERVE_SAGA,
    GET_MY_RESERVES_SAGA,
    REMOVE_RESERVE_SAGA
} from './sagaTypes';

// Получение записией
export const getBookingSagaAction = data => ({ type: GET_BOOKING_SAGA, data });
// Отправка данных для записи на сервер
export const sendBookingSagaAction = data => ({ type: SEND_BOOKING_SAGA, data });
// Регистрация пользователя
export const registrationSagaAction = data => ({ type: REGISTRATION_SAGA, data });
// Проверка кода из письма
export const checkEmailCodeSagaAction = data => ({ type: CHECK_EMAIL_CODE_SAGA, data });
// Восстановление пароля
export const recoveryPasswordSagaAction = data => ({ type: RECOVERY_PASSWORD_SAGA, data });
// Запрашиваем фильтры
export const getFiltersSagaAction = data => ({ type: GET_FILTERS_SAGA, data });
// Авторизация
export const signInSagaAction = data => ({ type: SIGN_IN_SAGA, data });
// Проверка хэша
export const checkHashSagaAction = data => ({ type: CHECK_HASH_SAGA, data });
// Получение абонементов пользователя
export const getSubscriptionsSagaAction = data => ({ type: GET_SUBSCRIPTIONS_SAGA, data });
// Записть на групповое занятие / отмена
export const bookingActionSagaAction = data => ({ type: BOOKING_ACTION_SAGA, data });
// Получение списка услуг
export const getServicesSagaAction = data => ({ type: GET_SERVICES_SAGA, data });
// Получение списка мастеров
export const getMastersSagaAction = data => ({ type: GET_MASTERS_SAGA, data });
// Получение даты и времени для записи
export const getTimetableSagaAction = data => ({ type: GET_TIMETABLE_SAGA, data });
// Сохранение записи на услугу
export const addScheduleReserveSagaAction = data => ({ type: ADD_SCHEDULE_RESERVE_SAGA, data });
// Получение списка записей на услуги
export const getMyReservesSagaAction = data => ({ type: GET_MY_RESERVES_SAGA, data });
// Удаление записи на услугу
export const removeReserveSagaAction = data => ({ type: REMOVE_RESERVE_SAGA, data });